import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { CheckboxProps } from '@mui/material';

import CheckBoxField from '@common/components/Form/CheckBoxField';

import { StyledGoalItemFormCheckBoxCloseButton, StyledGoalItemFormCheckBoxWrap } from './styled';

interface PropsType extends CheckboxProps {
	label: string;
	name: string;
	onRemove: () => void;
}

function GoalItemFormCheckBox({ label, name, onRemove, ...props }: PropsType) {
	const handleClick = () => {
		onRemove();
	};

	return (
		<StyledGoalItemFormCheckBoxWrap>
			{!props.checked && (
				<StyledGoalItemFormCheckBoxCloseButton onClick={handleClick}>
					<CloseIcon color="inherit" />
				</StyledGoalItemFormCheckBoxCloseButton>
			)}
			<CheckBoxField label={label} name={name} {...props} />
		</StyledGoalItemFormCheckBoxWrap>
	);
}

export default GoalItemFormCheckBox;
